import React from 'react';
import * as styles from './Description.module.scss';
const Description = ({
  description,
  classname
}) => {
  if (!description) {
    return null;
  }
  return description && /*#__PURE__*/React.createElement("div", {
    className: `${styles.root} ${classname || null}`,
    dangerouslySetInnerHTML: {
      __html: description
    }
  });
};
export default Description;